<script>
  import {createEventDispatcher} from 'svelte';
  import {differenceInMinutes, parse} from 'date-fns';

  import store from '../../../Stores/tipo-de-jornada-store';

  import Boton from "../../UI/Boton.svelte";
  import Icono from "../../UI/Icono.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";
  import Modal from "../../UI/Modal.svelte";
  import InputNumerico from "../../UI/InputNumerico.svelte";
  import Duracion from "../../UI/Duracion.svelte";

  const dispatch = createEventDispatcher();

  let tipoDeJornada, horas;
  $: tipoDeJornada = $store.tipo;
  $: horas = tipoDeJornada.horas || [];

  let editando = null;

  const nuevaHora = () => editando = {
    titulo: 'Nuevo intervalo',
    fila: -1,
    registro: {
      entrada: {
        minimo: [9, 0],
        maximo: [10, 0]
      },
      salida: {
        minimo: [14, 0],
        maximo: [15, 0]
      }
    }
  };

  const quitaHora = i => () => {
    const nuevasHoras = [...horas.slice(0, i), ...horas.slice(i + 1)];
    if (nuevasHoras.length) {
      store.actualizaCampo('horas', nuevasHoras);
    } else {
      store.quitaCampo('horas');
    }
  };

  const editaHora = i => () => editando = {
    titulo: 'Edición de intervalo',
    fila: i,
    registro: {
      entrada: {
        minimo: horas[i].entrada.minimo.split(':'),
        maximo: horas[i].entrada.maximo.split(':')
      },
      salida: {
        minimo: horas[i].salida.minimo.split(':'),
        maximo: horas[i].salida.maximo.split(':')
      }
    }
  };
  const cancelaEdicion = () => editando = null;

  const aceptaEdicion = () => {
    let registro = {
      entrada: {
        minimo: editando.registro.entrada.minimo.map(x => x.toString().padStart(2, '0')).join(':'),
        maximo: editando.registro.entrada.maximo.map(x => x.toString().padStart(2, '0')).join(':'),
      },
      salida: {
        minimo: editando.registro.salida.minimo.map(x => x.toString().padStart(2, '0')).join(':'),
        maximo: editando.registro.salida.maximo.map(x => x.toString().padStart(2, '0')).join(':'),
      }
    }, resultado;

    if (editando.fila === -1) {
      resultado = [...horas, registro];
    } else {
      resultado = horas.map((hora, i) => i === editando.fila ? registro : hora);
    }

    store.actualizaCampo('horas', resultado);
    calculaDuracion(resultado);

    editando = null;
  };

  const horaAFecha = (hora, manana = false) => {
    return parse(`2020-01-${manana ? 2 : 1} ${hora}`, 'yyyy-MM-dd HH:mm', new Date());
  };

  const calculaDuracion = (horas) => {
    const duracion = horas.reduce((suma, {entrada, salida}) => {
      entrada = entrada.minimo;
      salida = salida.minimo;
      
      if (entrada < salida) {
        return suma + differenceInMinutes(horaAFecha(salida), horaAFecha(entrada));
      } else {
        const mediaNocheDeHoy = horaAFecha('23:59'),
            mediaNocheDeManana = horaAFecha('00:00', true),
            minutosHastaMedianoche = differenceInMinutes(mediaNocheDeHoy, horaAFecha(entrada)),
            minutosDesdeMedianoche = differenceInMinutes(horaAFecha(salida, true), mediaNocheDeManana);

        return suma + minutosDesdeMedianoche + minutosHastaMedianoche + 1;
      }
    }, 0);

    tipoDeJornada.duracion = duracion - (tipoDeJornada.descansoObligatorio || 0);
    store.actualizaCampo('duracion', tipoDeJornada.duracion);
  }

  const actualizaEdicion = (campo, tipo, i) => e => {
    editando = {
      ...editando,
      registro: {
        ...editando.registro,
        [campo]: {
          ...editando.registro[campo],
          [tipo]: editando.registro[campo][tipo].map((valor, posicion) => posicion === i ? e.detail : valor)
        }
      }
    }
  };
</script>

<style>
    .horario {
        margin: var(--padding-global) 0;
    }

    table {
        margin: calc(var(--padding-global) / 2) 0 calc(var(--padding-global) * 2);
    }

    .edicion p {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .edicion span {
        margin: 0 calc(var(--padding-global) / 2);
    }

    td:last-child {
        width: 1%;
        white-space: nowrap;
    }

    tfoot th {
        text-align: right;
    }
</style>

<div class="horario">
    <Subtitulo>Horario</Subtitulo>

    <table>
        <thead>
        <tr>
            <th>Entrada</th>
            <th>Salida</th>
            <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        {#each horas as hora, i}
            <tr>
                <td>{hora.entrada.minimo} – {hora.entrada.maximo}</td>
                <td>{hora.salida.minimo} – {hora.salida.maximo}</td>
                <td>
                    <Boton tamano="pequeno" icono="edit" on:click={editaHora(i)}>Editar</Boton>
                    <Boton tamano="pequeno" tipo="peligro" icono="delete" on:click={quitaHora(i)}>
                        Editar
                    </Boton>
                </td>
            </tr>
        {/each}
        </tbody>
        <tfoot>
        <tr>
            <th colspan="2">Horas diarias:</th>
            <td>
                <Duracion minutos={tipoDeJornada.duracion}/>
            </td>
        </tr>
        </tfoot>
    </table>

    <Boton on:click={nuevaHora} type="button" tipo="pequeno">
        <Icono margen>add</Icono>
        Añadir intervalo
    </Boton>
</div>

{#if editando}
    <div class="edicion">
        <Modal on:cancel={cancelaEdicion} title={editando.titulo} estrecho>
            <p>
                <span>
                    <Icono svg="Entrada.svg" tamano={60}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('entrada', 'minimo', 0)} min={0} max={23}
                                   valor={editando.registro.entrada.minimo[0]}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('entrada', 'minimo', 1)} min={0} max={59}
                                   valor={editando.registro.entrada.minimo[1]}/>
                </span>
                –
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('entrada', 'maximo', 0)} min={0} max={23}
                                   valor={editando.registro.entrada.maximo[0]}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('entrada', 'maximo', 1)} min={0} max={59}
                                   valor={editando.registro.entrada.maximo[1]}/>
                </span>
            </p>
            <p>
                <span>
                    <Icono svg="Salida.svg" tamano={60}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('salida', 'minimo', 0)} min={0} max={23}
                                   valor={editando.registro.salida.minimo[0]}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('salida', 'minimo', 1)} min={0} max={59}
                                   valor={editando.registro.salida.minimo[1]}/>
                </span>
                –
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('salida', 'maximo', 0)} min={0} max={23}
                                   valor={editando.registro.salida.maximo[0]}/>
                </span>
                <span>
                    <InputNumerico on:cambio={actualizaEdicion('salida', 'maximo', 1)} min={0} max={59}
                                   valor={editando.registro.salida.maximo[1]}/>
                </span>
            </p>

            <div slot="footer">
                <Boton on:click={aceptaEdicion} tipo="ok">
                    <Icono margen tamano={16}>check</Icono>
                    Aceptar
                </Boton>

                <Boton on:click={cancelaEdicion}>
                    <Icono margen tamano={16}>close</Icono>
                    Cancelar
                </Boton>
            </div>
        </Modal>
    </div>
{/if}